(function(){
  function initTheme(scope){
    scope = scope || document;
    const btn=scope.querySelector ? scope.querySelector('[data-mobile-menu]') : null;
    const menu=document.querySelector('[data-mobile-panel]');
    if(btn&&menu&&!btn.dataset.bound){
      btn.dataset.bound='1';
      btn.addEventListener('click',()=>{
        const isOpen=menu.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        btn.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });
    }
    scope.querySelectorAll?.('[data-variant-select]').forEach(sel=>{
      if(sel.dataset.bound) return; sel.dataset.bound='1';
      sel.addEventListener('change',e=>{
        const option=e.target.options[e.target.selectedIndex];
        document.querySelectorAll('[data-product-price]').forEach(price=>{if(option.dataset.price) price.textContent=option.dataset.price;});
        document.querySelectorAll('input[name="id"]').forEach(i=>i.value=e.target.value);
      });
    });
  }
  document.addEventListener('DOMContentLoaded',()=>initTheme(document));
  document.addEventListener('shopify:section:load',e=>initTheme(e.target));
})();

/* v10 mobile product gallery indicator */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    if (gallery.dataset.galleryBound) return;
    gallery.dataset.galleryBound = '1';
    var dots = gallery.parentElement.querySelectorAll('.product-gallery-dot');
    if (!dots.length) return;
    var updateDots = function(){
      var width = gallery.clientWidth || 1;
      var index = Math.round(gallery.scrollLeft / width);
      dots.forEach(function(dot, i){ dot.classList.toggle('active', i === index); });
    };
    gallery.addEventListener('scroll', updateDots, {passive:true});
    window.addEventListener('resize', updateDots);
    updateDots();
  });
});


/* v12 recommendation carousel dots */
(function(){
  function initRecommendationDots(scope){
    (scope || document).querySelectorAll?.('[data-recommendation-row]').forEach(function(row){
      if(row.dataset.dotsBound) return;
      var wrap=row.parentElement;
      var dots=wrap.querySelectorAll('[data-recommendation-dots] .product-recommendation-dot');
      var items=row.querySelectorAll('[data-recommendation-item]');
      if(!dots.length || !items.length) return;
      row.dataset.dotsBound='1';
      function nearestIndex(){
        var left=row.scrollLeft, best=0, dist=Infinity;
        items.forEach(function(item,i){var d=Math.abs(item.offsetLeft-left);if(d<dist){dist=d;best=i;}});
        dots.forEach(function(dot,i){dot.classList.toggle('active',i===best);});
      }
      row.addEventListener('scroll',nearestIndex,{passive:true});
      dots.forEach(function(dot,i){dot.addEventListener('click',function(){items[i]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});});});
      nearestIndex();
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initRecommendationDots(document);});
  document.addEventListener('shopify:section:load',function(e){initRecommendationDots(e.target);});
})();

/* v17 Dawn-style AJAX cart drawer */
(function(){
  function money(cents){
    try{
      var code=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
      return new Intl.NumberFormat(undefined,{style:'currency',currency:code}).format((cents||0)/100);
    }catch(e){return '$'+((cents||0)/100).toFixed(2);}
  }
  function initCartDrawer(){
    var shell=document.querySelector('[data-cart-drawer-shell]');
    if(!shell||shell.dataset.bound) return;
    shell.dataset.bound='1';
    var drawer=shell.querySelector('[data-cart-drawer]');
    var body=shell.querySelector('[data-cart-drawer-body]');
    var foot=shell.querySelector('[data-cart-drawer-foot]');
    var count=shell.querySelector('[data-drawer-count]');
    var subtotal=shell.querySelector('[data-drawer-subtotal]');
    var cartUrl=shell.dataset.cartUrl||'/cart';
    var addUrl=(shell.dataset.cartAddUrl||'/cart/add')+'.js';
    var changeUrl=(shell.dataset.cartChangeUrl||'/cart/change')+'.js';
    var shippingThreshold=parseInt(shell.dataset.freeShippingThreshold||'5000',10);
    var shippingText=shell.querySelector('[data-free-shipping-text]');
    var shippingFill=shell.querySelector('[data-free-shipping-fill]');
    var checkoutButton=shell.querySelector('[data-cart-checkout]');

    function updateHeaderCount(n){
      document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=n;el.style.display=n?'flex':'none';});
      document.querySelectorAll('.shopify-cart-button').forEach(function(el){el.setAttribute('aria-label','Cart, '+n+' items');});
    }
    function openDrawer(){shell.classList.add('is-open');shell.setAttribute('aria-hidden','false');document.body.classList.add('cart-drawer-open');setTimeout(function(){drawer.focus?.();},50)}
    function closeDrawer(){shell.classList.remove('is-open');shell.setAttribute('aria-hidden','true');document.body.classList.remove('cart-drawer-open')}
    function render(cart){
      count.textContent=cart.item_count+' item'+(cart.item_count===1?'':'s');
      updateHeaderCount(cart.item_count);
      subtotal.textContent=money(cart.total_price);
      if(shippingText&&shippingFill){
        var remaining=Math.max(0,shippingThreshold-cart.total_price);
        var progress=shippingThreshold>0?Math.min(100,(cart.total_price/shippingThreshold)*100):100;
        shippingFill.style.width=progress+'%';
        if(remaining>0){
          shippingText.textContent='Spend '+money(remaining)+' more to get Free Shipping';
        }else{
          shippingText.textContent='You unlocked Free Shipping';
        }
      }
      if(!cart.items.length){
        body.innerHTML='<div class="sora-cart-drawer__empty">Your cart is empty.</div>';
        foot.hidden=true; return;
      }
      foot.hidden=false;
      body.innerHTML=cart.items.map(function(item,index){
        var img=item.featured_image&&item.featured_image.url ? '<a class="sora-cart-drawer__media" href="'+item.url+'"><img src="'+item.featured_image.url+'&width=240" alt=""></a>' : '';
        var variant=(item.variant_title&&item.variant_title!=='Default Title')?'<div class="sora-cart-drawer__variant">'+item.variant_title+'</div>':'';
        return '<div class="sora-cart-drawer__item" data-drawer-line="'+(index+1)+'">'+img+
          '<div class="sora-cart-drawer__details"><a class="sora-cart-drawer__title" href="'+item.url+'">'+item.product_title+'</a>'+variant+
          '<div class="sora-cart-drawer__price">'+money(item.final_line_price)+'</div>'+
          '<div class="sora-cart-drawer__controls"><div class="sora-cart-drawer__qty"><button type="button" data-drawer-minus aria-label="Decrease quantity">−</button><span>'+item.quantity+'</span><button type="button" data-drawer-plus aria-label="Increase quantity">+</button></div><button type="button" class="sora-cart-drawer__remove" data-drawer-remove>Remove</button></div></div></div>';
      }).join('');
    }
    function getCart(){return fetch(cartUrl+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render)}
    function change(line,qty){
      return fetch(changeUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
        .then(function(r){if(!r.ok) throw new Error('Cart update failed');return r.json();}).then(render);
    }
    if(checkoutButton&&!checkoutButton.dataset.bound){
      checkoutButton.dataset.bound='1';
      checkoutButton.addEventListener('click',function(){
        checkoutButton.disabled=true;
        checkoutButton.textContent='Loading…';
        var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        window.location.assign(root+'checkout');
      });
    }

    document.addEventListener('click',function(e){
      var close=e.target.closest('[data-cart-drawer-close]'); if(close){e.preventDefault();closeDrawer();return;}
      var icon=e.target.closest('.shopify-cart-button'); if(icon){e.preventDefault();getCart().then(openDrawer);return;}
      var item=e.target.closest('[data-drawer-line]'); if(!item)return;
      var line=parseInt(item.dataset.drawerLine,10); var qtySpan=item.querySelector('.sora-cart-drawer__qty span'); var qty=parseInt(qtySpan?.textContent||'1',10);
      if(e.target.closest('[data-drawer-plus]')){change(line,qty+1)}
      else if(e.target.closest('[data-drawer-minus]')){change(line,Math.max(0,qty-1))}
      else if(e.target.closest('[data-drawer-remove]')){change(line,0)}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&shell.classList.contains('is-open'))closeDrawer()});

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
      if(form.dataset.ajaxCartBound) return; form.dataset.ajaxCartBound='1';
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var submit=form.querySelector('[type="submit"]'); var old=submit&&submit.textContent;
        if(submit){submit.disabled=true;submit.textContent='Adding…';}
        var fd=new FormData(form);
        fetch(addUrl,{method:'POST',body:fd,headers:{'Accept':'application/json'}})
          .then(function(r){if(!r.ok) return r.json().then(function(j){throw new Error(j.description||'Unable to add to cart')});return r.json();})
          .then(function(){return getCart()})
          .then(openDrawer)
          .catch(function(err){alert(err.message||'Unable to add to cart');})
          .finally(function(){if(submit){submit.disabled=false;submit.textContent=old;}});
      });
    });

    var startX=null, currentX=null;
    drawer.addEventListener('touchstart',function(e){if(e.touches.length===1){startX=e.touches[0].clientX;currentX=startX;}},{passive:true});
    drawer.addEventListener('touchmove',function(e){if(startX!==null&&e.touches.length===1)currentX=e.touches[0].clientX;},{passive:true});
    drawer.addEventListener('touchend',function(){if(startX!==null&&currentX-startX>70)closeDrawer();startX=currentX=null;});
  }
  document.addEventListener('DOMContentLoaded',initCartDrawer);
  document.addEventListener('shopify:section:load',initCartDrawer);
})();


/* v18 remove injected discount-savings popup only */
(function(){
  function removeSavingsPopup(root){
    var nodes=(root||document).querySelectorAll ? (root||document).querySelectorAll('body *') : [];
    for(var i=0;i<nodes.length;i++){
      var el=nodes[i];
      if(!el || !el.textContent) continue;
      var text=el.textContent.replace(/\s+/g,' ').trim().toLowerCase();
      if(text.length>180) continue;
      if(text.indexOf('you got')!==-1 && text.indexOf('off your order')!==-1){
        var box=el.closest('[role="dialog"],[role="alert"],[aria-live],[class*="popup" i],[class*="modal" i],[class*="toast" i],[class*="notification" i]');
        if(box && box!==document.body && box!==document.documentElement){ box.remove(); return; }
        try{
          var cs=getComputedStyle(el);
          if((cs.position==='fixed'||cs.position==='sticky') && el!==document.body){ el.remove(); return; }
        }catch(e){}
      }
    }
  }
  document.addEventListener('DOMContentLoaded',function(){
    removeSavingsPopup(document);
    var observer=new MutationObserver(function(){removeSavingsPopup(document);});
    observer.observe(document.body,{childList:true,subtree:true});
  });
})();
